// features/position/positionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

// Async thunk: Pozisyonları API'den çek
export const fetchPositions = createAsyncThunk(
  "positions/fetchPositions",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/positions/positionNames");
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const positionSlice = createSlice({
  name: "positions",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPositions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPositions.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchPositions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Pozisyonlar alınamadı.";
      });
  },
});

export default positionSlice.reducer;
